import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=105ab20c"
import script from "./IconCheck.vue?vue&type=script&lang=js"
export * from "./IconCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports